<a
    role="link"
    tabindex="0"
    class="text-sm font-medium cursor-pointer text-primary-700 hover:text-primary-800"
    (click)="downloadAttachment()"
    (keydown.enter)="downloadAttachment()"
>
    {{ params.value }}
</a>
